import { render, staticRenderFns } from "./acuTechnic2.vue?vue&type=template&id=2e3c9bf6&scoped=true&"
var script = {}
import style0 from "./acuTechnic2.vue?vue&type=style&index=0&id=2e3c9bf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3c9bf6",
  null
  
)

export default component.exports